<template>
  <app-content-admin>
    <template slot="header">{{ $t("orders") }}</template>

    <v-layout row wrap>
      <v-flex xs12>
        <v-row>
          <v-col cols="3">
            <v-text-field label="Status" outlined dense></v-text-field>
          </v-col>

          <v-col cols="3">
            <v-btn color="primary">Search</v-btn>
          </v-col>
        </v-row>
      </v-flex>

      <v-flex xs12>
        <v-card class="pa-3">
          <table class="table table-fluid no-wrap">
            <thead>
              <th scope="col">Order No</th>
              <th scope="col">Merchant</th>
              <th scope="col">Package</th>
              <th scope="col">Status</th>
              <th scope="col">Date</th>
              <th scope="col">Action</th>
            </thead>
            <tbody>
              <tr v-for="row in rows" :key="row.id">
                <td>#{{ row.order_no }}</td>
                <td>{{ row.merchant }}</td>
                <td>{{ row.plan }}</td>
                <td>
                  <order-status :status="row.status"></order-status>
                </td>
                <td>{{ row.date }}</td>
                <td>
                  <v-btn @click="view(row.id)" color="primary" small>
                    View
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </table>
          <v-layout justify-center>
            <v-flex xs8>
              <div class="text-xs-center" v-if="pages > 0">
                <v-pagination
                  v-model="page"
                  :length="pages"
                  @input="onListChange"
                ></v-pagination>
              </div>
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>
    </v-layout>

    <detail-dialog
      :order_id="order_id"
      v-model="orderDialog"
      @refresh="search"
    ></detail-dialog>
  </app-content-admin>
</template>

<script>
import OrderStatus from '@/components/status/OrderStatus'
import DetailDialog from "@/views/order/detail-dialog";

export default {
  data: () => ({
    rows: [],
    pages: 0,
    page: 1,
    form: {
      offset: 1,
      page: 10,
    },

    status: [
      { name: "Active", value: "active" },
      { name: "Inactive", value: "inactive" },
    ],

    orderDialog: false,
    order_id: null,
  }),

  components: {
    DetailDialog,
    OrderStatus
  },

  mounted() {
    this.search();
  },

  methods: {
    search(offset = 10, page = 1) {
      this.form.offset = offset;
      this.form.page = page;

      let loader = this.$loading.show();

      axios
        .post(api.path("order.list"), this.form)
        .then((res) => res.data)
        .then((res) => {
          this.rows = res.data.data;
          console.log(this.rows);
          this.pages = res.data.pages;
          loader.hide();
        });
    },

    view(id) {
      this.order_id = id;
      this.orderDialog = true;
    },

    onListChange(page) {
      this.page = page;
      this.search(10, page);
    },
  },
};
</script>
